import { render, staticRenderFns } from "./EntryHistoryRestore.vue?vue&type=template&id=4bbb3826&scoped=true"
import script from "./EntryHistoryRestore.vue?vue&type=script&lang=js"
export * from "./EntryHistoryRestore.vue?vue&type=script&lang=js"
import style0 from "./EntryHistoryRestore.vue?vue&type=style&index=0&id=4bbb3826&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbb3826",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bbb3826')) {
      api.createRecord('4bbb3826', component.options)
    } else {
      api.reload('4bbb3826', component.options)
    }
    module.hot.accept("./EntryHistoryRestore.vue?vue&type=template&id=4bbb3826&scoped=true", function () {
      api.rerender('4bbb3826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/EntryHistoryRestore.vue"
export default component.exports